import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface VisitorBookingSearchBarProps {
    value: string;
    onChange: (newValue: string) => void;
    fullWidth?: boolean;
}

const VisitorBookingSearchBar = (props: VisitorBookingSearchBarProps) => {

    const { t } = useTranslation();

    return (
        <TextField
            size={'medium'}
            variant={'outlined'}
            placeholder={t('visitor_booking.search_placeholder')}
            value={props.value}
            onChange={event => props.onChange(event.target.value)}
            InputProps={{
                className: 'text-foreground border-foreground border',
                startAdornment: (
                    <InputAdornment position={'start'}>
                        <SearchIcon className={'text-foreground'} />
                    </InputAdornment>
                ),
            }}
            fullWidth={props.fullWidth}
        />
    );
};

export default VisitorBookingSearchBar;
